export default "__VITE_ASSET__8998c3ca__"